import { timeOffsetCalculator } from '@/common/TimeOffsetCalculator';
import { formatDate, formatTime } from '@/common/filters';

export function serverDate() {
  return new Date(timeOffsetCalculator.getServerTime());
}

export function serverTimeToClientTime(serverTime: number): number {
  return serverTime - timeOffsetCalculator.clientTimeToServerTime / 1000;
}

export function serverDateToClientDate(serverDate: Date): Date {
  return new Date(serverDate.getTime() - timeOffsetCalculator.clientTimeToServerTime);
}

export function clientTimeToServerTime(serverTime: number): number {
  return serverTime + timeOffsetCalculator.clientTimeToServerTime / 1000;
}
